export default {
  html: $('html'),
  body: $('body'),
  htmlFixedState: false,
  scrollTopState: 0,
  htmlFixed() {
    const scrollTop = $(document).scrollTop()
    this.html.toggleClass('is-fixed')
    this.htmlFixedState = !this.htmlFixedState
    if (this.htmlFixedState) {
      this.scrollTopState = scrollTop
      this.body.css({
        top: -this.scrollTopState,
      })
    } else {
      this.body.css({
        top: '',
      })
      $('html, body').animate({ scrollTop: this.scrollTopState }, 0)
    }
  },
}
